import { render } from "./StudentEnrollments.vue?vue&type=template&id=25c7c0b1&scoped=true"
import script from "./StudentEnrollments.vue?vue&type=script&lang=js"
export * from "./StudentEnrollments.vue?vue&type=script&lang=js"

import "./StudentEnrollments.vue?vue&type=style&index=0&id=25c7c0b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c7c0b1"]])

export default __exports__